var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBubbleChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9D6550E6-BE38-4FF4-98BE-CE9A204E8944") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.5,15.999 L5.721307,16.0033682 C8.65758477,16.1194878 11,18.5360732 11,21.499 L11,21.499 L10.9956353,21.7203088 C10.8796074,24.656633 8.46487805,27 5.5,27 L5.5,27 L5.27876264,26.9956335 C2.34336704,26.8795592 0,24.463878 0,21.499 C0,18.462 2.462,15.999 5.5,15.999 L5.5,15.999 Z M10.5,0 L10.7118938,0.00489627988 C13.0994416,0.11547102 15,2.08502857 15,4.5 L15,4.5 L14.9951037,4.71181294 C14.884529,7.09849796 12.9149714,9 10.5,9 L10.5,9 L10.2881871,8.99510134 C7.90150204,8.88447347 6,6.914 6,4.5 C6,2.014 8.015,0 10.5,0 L10.5,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,19 L5.21693275,19.0046183 C7.87823961,19.1181524 10,21.3106842 10,24 L10,24 L9.99538165,24.2169328 C9.88184765,26.8782396 7.68931579,29 5,29 L5,29 L4.78306725,28.9953817 C2.12176039,28.8818476 0,26.6893158 0,24 C0,21.238 2.238,19 5,19 L5,19 Z M8.501,1.24344979e-14 L8.75613718,0.00375603306 C13.3321058,0.138657851 17,3.89036364 17,8.5 L17,8.5 L16.996244,8.75513718 C16.8613425,13.3311058 13.1096545,16.999 8.501,16.999 L8.501,16.999 L8.24580828,16.995244 C3.66885818,16.8603425 0,13.1086545 0,8.5 C0,3.805 3.806,1.24344979e-14 8.501,1.24344979e-14 L8.501,1.24344979e-14 Z M24,11 L24.1493158,11.0054832 C25.1845145,11.0817975 26,11.9452273 26,13 L26,13 L25.9945168,13.1491916 C25.9182025,14.1836033 25.0547727,15 24,15 L24,15 L23.8508144,14.9945109 C22.8164855,14.9181157 22.001,14.0538182 22.001,13 C22.001,11.895 22.896,11 24,11 L24,11 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-Page-Builder-v1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.0-WebPageBuilder-EmptyWidgets",
    transform: "translate(-203.000000, -512.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WPB-Widgets",
    transform: "translate(0.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Components",
    transform: "translate(160.000000, 376.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(43.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-Builder/Bubble-Chart/40dp",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Purple-Light",
    transform: "translate(20.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#ACA6FF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey",
    mask: "url(#mask-2)",
    fill: "#A5A5A5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20.000000, -6.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Purple-",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E5E5E5",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Zinier-Colors/Grey-Dark",
    mask: "url(#mask-4)",
    fill: "#727272"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.000000, -6.000000)",
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleChart);
export default __webpack_public_path__ + "static/media/bubbleChart.6bc32fa2a84555ddc9dd3b8555d39e81.svg";
export { ForwardRef as ReactComponent };